<template>
  <div class="head" :class="colorFlag>1?'heads':''">
    <div class="headt clearfix">
      <div class="logo">
        <a href="/" title>
          <img src="/static/logo1.png" />
          <img src="/static/logo2.png" />
        </a>
      </div>
      <div class="ft28 logotit">宝钢金属有限公司</div>

      <div class="luang">
        <a href="#" title>中</a>
        <a href="#" title>EN</a>
      </div>
      <div class="ssan">
        <a href="javascript:;" title @click="showSearch">
          <img src="/static/headico2.png" />
          <img src="/static/headico2_.png" />
        </a>
      </div>
      <div class="navlin" @click="phoneMenuFlag=!phoneMenuFlag" :class="phoneMenuFlag?'cur':''">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <div class="headcon">
      <div class="clearfix">
        <div class="nav" :style="{display:phoneMenuFlag?'block':'none'}">
          <ul class="clearfix">
            <li>
              <router-link
                :style="{color:!$utils.isMobile()&&colorFlag>1?'#003586':'#fff'}"
                :to="{path:'/'}"
                class="yj"
                :class="$route.name=='home'?'cur':''"
              >首页</router-link>
            </li>
            <li v-for="nav in menuList" :key="nav.nodeId" :style="{display:nav.isShow>0?'':'none'}">
              <a
                :style="{color:!$utils.isMobile()&&colorFlag>1?'#003586':'#fff'}"
                v-if="nav.nodeIndexName=='product'"
                :href="nav.linkUrl"
                target="_blank"
                title
                class="yj"
              >{{nav.nodeName}}</a>
              <router-link
                v-if="nav.nodeIndexName!='product'"
                :style="{color:!$utils.isMobile()&&colorFlag>1?'#003586':'#fff'}"
                :to="{name:nav.pathName,params:{pId:nav.nodeId,cId:nav.hasChilds?nav.childs[0].nodeId:''}}"
                class="yj"
                :class="$route.name==$utils.getPathByNodeIndexName(nav.nodeIndexName).name?'cur':''"
              >{{nav.nodeName}}</router-link>

              <div class="ej clearfix" v-if="nav.childs&&nav.childs.length>0">
                <router-link
                  v-for="cell in nav.childs"
                  :key="cell.nodeId"
                  :to="{name:nav.pathName,params:{pId:nav.nodeId,cId:cell.nodeId}}"
                  title
                >{{cell.nodeName}}</router-link>
              </div>
            </li>
          </ul>
        </div>
        <div
          class="right"
          v-if="$utils.isMobile()"
          :style="{display:phoneSearchFlag?'block':'none'}"
        >
          <div class="sous clearfix">
            <form>
              <input
                type="search"
                :style="{borderColor:phoneSearchFlag?'#fff':'#003586'}"
                v-model="searchVal"
                class="txt"
              />
              <input
                type="button"
                :style="{color:phoneSearchFlag?'#fff':'#003586'}"
                @click="searchFun"
                class="but"
                value="搜索"
              />
            </form>
          </div>

          <div class="luang">
            <a href="#" title>中</a>
            <a href="#" title>EN</a>
          </div>
          <div class="ygrk">
            <a href="http://vpn.baosteel.com/" target="_blank">员工入口</a>
          </div>
        </div>
        <div class="right" v-else>
          <div class="sous clearfix">
            <form>
              <input type="search" v-model="searchVal" class="txt" />
              <input type="button" @click="searchFun" class="but" value="搜索" />
            </form>
          </div>

          <div class="luang">
            <a href="#" title>中</a>
            <a href="#" title>EN</a>
          </div>
          <div class="ygrk">
            <a href="http://vpn.baosteel.com/" target="_blank">员工入口</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.headt {
  width: 100%;
  max-width: 100%;
  padding: 35px 45px 18px;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -ms-box-sizing: border-box;
  .logotit {
    color: #fff;
  }
  .logo img:last-child {
    display: none;
  }
  .logo img:first-child {
    display: block;
  }
}
.head {
  position: fixed;
  background: rgba(16, 22, 54, 0.75);
}
.heads {
  border-bottom: 2px solid $--color-primary;
  background: #fff;
}
.headcon {
  padding: 0 45px 10px;
  background: none;
}
.heads .headcon .right .sous input,
.heads .nav ul li a.yj {
  color: $--color-primary;
}
.heads .nav ul li a.yj.cur,
.heads .nav ul li:hover a.yj {
  border-bottom-color: $--color-primary;
}
.heads .headcon .right .sous .txt {
  border-color: $--color-primary;
}
.heads .luang a {
  color: $--color-primary;
}
.heads .luang a:last-child {
  background: url(/static/xian0_.png) no-repeat left center;
}
.heads .headt .logo img:first-child {
  display: none;
}
.heads .headt .logo img:last-child {
  display: block;
}
.heads .headt .logotit {
  color: #907a7a;
}
@media screen and (max-width: 768px) {
  .headt {
    padding: 5px 5%;
  }
}
@media screen and (max-width: 338px) {
  .headt {
    padding: 5px 3.125%;
    width: auto;
  }
}
</style>
<script>
import { getMenu } from "@/api/index";
export default {
  data() {
    return {
      menuList: [],
      searchVal: "",
      phoneSearchFlag: true,
      phoneMenuFlag: false,
      colorFlag: 1 //1 白色，2 彩色
    };
  },
  created() {
    if (!localStorage.bwsteelMenus) {
      this.getMenuFun();
    } else {
      let menus = JSON.parse(localStorage.bwsteelMenus);
      this.$set(this.$data, "menuList", menus);
    }
  },
  mounted() {
    this.showSearch();
    // this.handleScroll();
    //初始化一个window滚动监听事件
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    getMenuFun() {
      getMenu().then(res => {
        if (res.data.code === 1000) {
          let datas = res.data.data[0].childs.map(item => {
            if (item.childs) {
              item.hasChilds = true;
            }
            item.path = this.$utils.getPathByNodeIndexName(
              item.nodeIndexName
            ).url;
            item.pathName = this.$utils.getPathByNodeIndexName(
              item.nodeIndexName
            ).name;
            return item;
          });
          localStorage.setItem("bwsteelMenus", JSON.stringify(datas));
          this.$set(this.$data, "menuList", datas);
        } else {
          this.$message.error("栏目获取失败！");
        }
      });
    },
    showSearch() {
      if (this.$utils.isMobile()) {
        this.phoneSearchFlag = !this.phoneSearchFlag;
      } else {
        this.phoneSearchFlag = true;
      }
    },
    searchFun() {
      if (!this.searchVal) {
        this.$alert("请输入搜索关键字！", "信息", {
          confirmButtonText: "确定"
        });
      } else {
        this.$router.push({ name: "search", query: { key: this.searchVal } });
      }
    },
    handleScroll() {
      // 监听滚动距离  控制头部header样式
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (document.querySelector(".conBox")) {
        var offsetTop = document.querySelector(".conBox").offsetTop;
        // if (!this.$utils.isMobile()) {
        //   this.colorFlag = 1;
        // } else {
        if (offsetTop - scrollTop <= 435) {
          this.colorFlag = 2;
        } else {
          this.colorFlag = 1;
        }
      }
      // }
    }
  }
};
</script>